export default __webpack_public_path__ + "static/about-us-img-8ed68e995782cd7efb733f7089d6aff4.png";